import React from "react";

const SpeakerOnIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M11 4.5 6.2 8.6H3.2v6.8h3l4.8 4.1z" fill="currentColor" />
    <path
      d="M15.2 9.1a4.2 4.2 0 0 1 0 5.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M18 6.6a7.8 7.8 0 0 1 0 10.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const SpeakerOffIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M11 4.5 6.2 8.6H3.2v6.8h3l4.8 4.1z" fill="currentColor" />
    <path
      d="M15.4 9.6l4.4 4.8M19.8 9.6l-4.4 4.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const PlayIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M8 5.5v13L18.5 12z" fill="currentColor" />
  </svg>
);

/**
 * One side of the A/B video comparison: the video plus the overlays that show
 * whether it is the side currently playing and whether it is the audible one.
 * The forwarded ref points at the underlying <video> element.
 */
const ComparisonVideo = React.forwardRef(
  (
    {
      src,
      label,
      selectedClassName = "",
      hasStarted = false,
      isPlaying = false,
      isAudible = false,
      onSoundToggle,
      onMouseEnter,
      onMouseLeave,
      onVideoClick,
      onVideoDoubleClick,
      onPlay,
      onPause,
      onEnded,
      onCanPlay,
    },
    ref
  ) => (
    <div
      className={`video-frame${isPlaying ? " is-playing" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <video
        ref={ref}
        controls
        className={selectedClassName}
        preload="auto"
        playsInline
        src={src}
        aria-label={label}
        tabIndex={0}
        onClick={onVideoClick}
        onDoubleClick={onVideoDoubleClick}
        onPlay={onPlay}
        onPause={onPause}
        onEnded={onEnded}
        onCanPlay={onCanPlay}
      >
        Your browser does not support the video tag.
      </video>

      {!hasStarted && (
        <button
          type="button"
          className="video-start-overlay"
          onClick={(event) => {
            event.stopPropagation();
            onVideoClick();
            event.currentTarget.parentElement?.querySelector("video")?.focus();
          }}
          aria-label={`Play ${label}`}
        >
          <PlayIcon />
        </button>
      )}

      <button
        type="button"
        className={`video-sound-toggle${isAudible ? " is-on" : ""}`}
        onClick={onSoundToggle}
        title={isAudible ? "Turn sound off" : "Turn sound on"}
        aria-label={isAudible ? "Turn sound off" : "Turn sound on"}
      >
        {isAudible ? <SpeakerOnIcon /> : <SpeakerOffIcon />}
      </button>

      {isPlaying && (
        <span className="video-playing-badge">
          <span className="video-playing-dot" />
          Playing
        </span>
      )}
    </div>
  )
);

ComparisonVideo.displayName = "ComparisonVideo";

export default ComparisonVideo;
